import React from 'react';
import PropTypes from 'prop-types';

import { DemoPage } from '../../partials';

// Import code snippets as text.
const html = require('!raw-loader!flexbox-patterns/src/examples/stream.html');
const css = require('!raw-loader!flexbox-patterns/src/styles/stream.css');

export const StreamDemo = ({ name }) => (
  <DemoPage title={name} html={html} css={css}>
    <p>
      This is a bit of a weird example, because it&rsquo;s not completely
      realistic, but I really wanted to show you an interesting quirk to{' '}
      <code>flex-direction</code>.
    </p>

    <p>
      Let&rsquo;s say you have a list of posts that you want to show to the
      user. If you&rsquo;ve just retrieved this data from an API, then chances
      are good that it&rsquo;s sorted from oldest to most recent. But you
      can&rsquo;t just display the posts in this order, because in a Stream
      (like on Facebook or Twitter), you actually want the most recent posts at
      the <em>top</em>.
    </p>

    <p>
      Assuming you didn&rsquo;t want to just sort the data in JavaScript, you
      could use
      <code>flex-direction: column-reverse</code> to list the posts vertically,
      but in the reverse order than they appear in the DOM.
    </p>

    <p>
      But here&rsquo;s the weird quirk! If you try to select the text of all of
      the posts, you&rsquo;ll see that your selection will enter each post from
      the opposite direction you expect. I&rsquo;m sure this has something to do
      with the fact that the DOM elements themselves haven&rsquo;t been
      rearranged (the browser is just drawing them in a different order) &mdash;
      but I&rsquo;m not sure why browsers don&rsquo;t account for this.
    </p>
  </DemoPage>
);

StreamDemo.propTypes = {
  name: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./ui/views/demos/StreamDemo.js